export function replaceSpacesInImageUrl(imageUrl) {
    // console.log('image-url',imageUrl)
    if (imageUrl && imageUrl?.includes(' ')) {
        // console.log('working---')
        return imageUrl.replace(/ /g, "%20");
        
    }
    return imageUrl;
}
